import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || window.location.hash;
    const m = hash.match(/session_id=([^&]+)/);
    const session_id = m ? m[1] : null;

    if (!session_id) {
      navigate("/admin/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const r = await api.post("/auth/session", { session_id });
        setUser(r.data);
        // Clean URL
        window.history.replaceState(null, "", "/admin");
        navigate(r.data.is_admin ? "/admin" : "/admin/login", {
          replace: true,
          state: { user: r.data },
        });
      } catch (e) {
        navigate("/admin/login", { replace: true });
      }
    })();
  }, [location.hash, navigate, setUser]);

  return (
    <div data-testid="auth-callback" className="p-16 text-white/40">
      Authenticating…
    </div>
  );
}
